/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./whep.defs.js";
export { main as default } from "./whep.defs.js";
